import { render, staticRenderFns } from "./EditPanel.vue?vue&type=template&id=5d0d9166&scoped=true&"
import script from "./EditPanel.vue?vue&type=script&lang=js&"
export * from "./EditPanel.vue?vue&type=script&lang=js&"
import style0 from "./EditPanel.vue?vue&type=style&index=0&id=5d0d9166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d9166",
  null
  
)

export default component.exports